import { Link } from "react-router-dom";

const ThankYouCart = props => (
  <div className="success">
    <div className="success__content">
      <img src="../assets/toolkit/images/check.svg" alt="" />
      <h1>The purchase was successfull</h1>
      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam</p>
      <div className="buttons">
        <Link to="/floors" className="button button-hollow">Go to Floors</Link>
        <Link to="/invoices" class="button">Invoices</Link>
      </div>
    </div>
  </div>
)

export default ThankYouCart;